import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import Box from '@mui/material/Box';
import Button, { ButtonColor } from '../Button';

export type ConfirmDialogProps = {
  open: boolean;
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  color?: ButtonColor;
  confirmColor?: ButtonColor;
  isLoading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  padding?: string;
  fullWidthActions?: boolean;
};

const ConfirmDialog = ({
  title,
  content,
  onCancel,
  onConfirm,
  open,
  color = 'primary',
  confirmColor,
  isLoading = false,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  padding = '2em',
  fullWidthActions = false,
}: ConfirmDialogProps) => {
  return (
    <Dialog open={open} sx={{ maxWidth: '100%' }}>
      <Box sx={{ padding }}>
        <DialogTitle sx={fullWidthActions ? { paddingLeft: 0, paddingRight: 0, paddingTop: 0 } : undefined}>
          {title}
        </DialogTitle>
        <DialogContent sx={fullWidthActions ? { paddingLeft: 0, paddingRight: 0 } : undefined}>
          {content}
        </DialogContent>
        <DialogActions
          sx={
            fullWidthActions
              ? { padding: 0, marginTop: '24px', gap: '16px', '& > *': { flex: 1, margin: 0 } }
              : undefined
          }
        >
          <Button
            disabled={isLoading}
            type="outline"
            color={color}
            onClick={() => {
              onCancel();
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            isLoading={isLoading}
            color={confirmColor ?? color}
            onClick={() => {
              onConfirm();
            }}
          >
            {confirmLabel}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ConfirmDialog;
